import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../utils/api';

export default function NextChoicesPanel({ storyId, childId }) {
  const [choices, setChoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [generating, setGenerating] = useState(null);
  const navigate = useNavigate();

  const loadChoices = async () => {
    if (loaded || loading) return;
    setLoading(true);
    try {
      const res = await API.post(`/stories/${storyId}/next-choices`);
      setChoices(res.data.choices || []);
      setLoaded(true);
    } catch {
      setLoaded(true);
    } finally {
      setLoading(false);
    }
  };

  const pickChoice = async (choice) => {
    setGenerating(choice.id);
    // Navigate to generate page with the choice pre-filled as custom prompt
    const params = new URLSearchParams({
      childId: childId || '',
      customPrompt: `Continue the story: ${choice.title}. ${choice.description}`,
      fromChoice: 'true',
    });
    navigate(`/dashboard/generate?${params.toString()}`);
  };

  return (
    <div className="mt-4 pt-4" style={{ borderTop: '1px solid var(--border-purple)' }}>
      <div className="text-center mb-3">
        <span style={{ fontSize: '24px' }}>🤔</span>
        <h6 className="fw-bold mt-2 mb-1" style={{ color: 'var(--text-main)', fontFamily: "'Fredoka One',cursive" }}>
          What happens next?
        </h6>
        <p className="text-muted small mb-0">Pick a path for tomorrow night's story</p>
      </div>

      {!loaded && !loading && (
        <div className="text-center">
          <button className="btn btn-outline-secondary rounded-pill px-4" onClick={loadChoices}
            style={{ borderColor: 'var(--border-purple)', color: 'var(--text-muted2)' }}>
            <i className="bi bi-magic me-2"></i>Show me the options
          </button>
        </div>
      )}

      {loading && (
        <div className="text-center py-3">
          <div className="spinner-border spinner-border-sm" style={{ color: '#6f42c1' }}></div>
          <p className="text-muted small mt-2 mb-0">Imagining possibilities…</p>
        </div>
      )}

      {loaded && choices.length > 0 && (
        <div className="d-flex flex-column gap-3">
          {choices.map(choice => (
            <button key={choice.id}
              className="btn text-start p-3 rounded-4 w-100"
              style={{
                background: generating === choice.id ? 'var(--purple-section)' : 'var(--item-bg)',
                border: `1px solid ${generating === choice.id ? '#6f42c1' : 'var(--border-purple)'}`,
                transition: 'all 0.2s',
              }}
              onClick={() => pickChoice(choice)}
              disabled={generating !== null}>
              <div className="d-flex align-items-center gap-3">
                <span style={{ fontSize: '28px', flexShrink: 0 }}>{choice.emoji}</span>
                <div className="flex-grow-1">
                  <div className="fw-bold" style={{ color: 'var(--text-main)', fontSize: '15px' }}>{choice.title}</div>
                  <div className="text-muted small mt-1">{choice.description}</div>
                </div>
                <i className="bi bi-arrow-right text-muted" style={{ flexShrink: 0 }}></i>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
